import { useTranslation } from 'react-i18next';
import { IntegrationGroupFilter } from './types';

// Group ids stay the logic keys; only the rendered label is localized
export default function useIntegrationGroupLabels(): Record<IntegrationGroupFilter, string> {
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.Groups' });

  return {
    all: t('all', { defaultValue: 'All' }),
    bankDataAndVerification: t('bankDataAndVerification', { defaultValue: 'Bank Data & Verification' }),
    paymentProcessing: t('paymentProcessing', { defaultValue: 'Payment Processing' }),
    accountingAndErp: t('accountingAndErp', { defaultValue: 'Accounting & ERP' }),
  };
}
